import * as type from '../ActionTypes';

const initialState = {
  loading: false,
  error: null,
  savedData: false
};

export default function paymentReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.PATCH_PAYMENT_FIXED_REQUEST:
      return {
        ...state,
        loading: true,
        savedData: false,
        error: null
      };
    case type.PATCH_PAYMENT_FIXED_SUCCESS:
      return {
        ...state,
        loading: false,
        savedData: true,
        error: null
      };
    case type.PATCH_PAYMENT_FIXED_FAILURE:
      return {
        ...state,
        loading: false,
        savedData: false,
        error: action.error
      };
    case type.PATCH_PAYMENT_TIMESHEET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case type.PATCH_PAYMENT_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case type.PATCH_PAYMENT_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
